import { addAutomation, deleteAutomation, editAutomation, fetchAutomationList, fetchExportData, getAutomationListCnt, getDartDetails } from './automation_common_func';

type UserSurveyProps = {
  setSaveTriggered: any;
  setOverlayName: any;
  exportBtnClicked: boolean;
  tenant: string;
  setExportBtnClicked: any;
  dartSpecs: any;
  dartNo: number;
  rowID: number;
  saveBtnClicked: boolean;
  setSaveBtnClicked: any;
  setOverlayOpen: any;
  setExportDetails: any;
  formData: any;
  setFormData: any;
  overlayName: string;
  setErrorToast: any;
  setToastMessage: any;
  setIsToast: any;
  data: any;
  func: any;
  searchVal: string;
  pageNo: number;
  setTotalPages: any;
  setTotalRecords: any;
  setDartSpecs: any;
  deleteSurvey: any;
  setDeleteSurvey: any;
  setDeleteDisabled: any;
  isRefresh: boolean;
  setRefresh: any;
  setRefreshToast?: any;
  isFilter?: boolean;
  dropDownValue1?: string;
  setIsFilter?: any;
  dropdownValue2?: string;
  filterArray?: string[];
  newData: any;
  selectedRowIdInTable: any[]
  setLoading?: any;
  setSpinnerLoad?: any;
}

const surveyConfiguration = (props: UserSurveyProps) => {
  const getUserSurveyAutomationList = async (whereCondition: any, limit: any = null, offset: any = null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        if (props.overlayName === 'editSurvey') {
          props.setFormData({
            ...props.formData,
            name: data[0]?.automationName,
            description: data[0]?.description,
            jsonData: JSON.parse(data[0]?.jsonValue)
          });
          props.setSpinnerLoad(false);
        } else {
          props.setLoading(true);
          props.func(data);
        }
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getUserSurveyAutomationList error=", error);
      props.func([]);
    }
  };

  const getExportData = async (condition: object) => {
    try {
      const { data, status } = await fetchExportData(condition);

      if (status === 'success') {
        props.setExportDetails && props.setExportDetails(data);
      }
    } catch (error) {
      console.log("getExportData error=", error);

      props.setExportDetails([]);
    }

    props.setExportBtnClicked(false);
  }

  const deleteUnattachedAutomation = async (ids: any) => {
    try {
      const { data, status } = await deleteAutomation(ids, 'userSurvey', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setDeleteDisabled(true);
        props.setDeleteSurvey(false);
        props.setIsToast(true);
        //getUserSurveyAutomationList({ dartid: props.dartNo, types: 'userSurvey' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`User ${props.selectedRowIdInTable.length < 2 ? 'survey' : 'surveys'} deletion failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      props.setToastMessage(`User ${props.selectedRowIdInTable.length < 2 ? 'survey' : 'surveys'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const createAutomation = async (automationName: string, description: string, jsonValue: string, dartid: number, tenant: string) => {
    try {
      const { status } = await addAutomation(automationName, description, jsonValue, dartid, 'userSurvey', tenant);

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 2000);

        //getUserSurveyAutomationList({ dartid: dartid, types: 'userSurvey' }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${automationName} survey automation creation failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("createAutomation error=", error);
      props.setToastMessage(`${automationName} survey automation creation failed`);
      props.setErrorToast(true);
    }
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string) => {
    try {
      const { status } = await editAutomation(automationName, description, jsonVal, dartid, id, tenant, 'userSurvey');

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 1000);

        getUserSurveyAutomationList({ dartid: dartid, types: 'userSurvey' }, 50, props.pageNo);
      } else if (status === 'failed') {
        props.setToastMessage("This survey can't be edited as it is already configured");
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 1000);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} survey automation`);
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 1000);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} survey automation`);
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setSaveBtnClicked(false);
      }, 1000);
    }
  }

  if (props.dartSpecs.length === 0) {
    getDartDetails(props.dartNo, props.setDartSpecs);
  } else if (props.isRefresh) {
    props.setRefresh(false);
    props.setRefreshToast(true);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '' && props.overlayName === '') {
    getUserSurveyAutomationList({ dartid: props.dartNo, function: 'search', search: props.searchVal, types: 'userSurvey' }, 50, props.pageNo);

    getAutomationListCnt({ dartid: props.dartNo, function: 'search', search: props.searchVal, types: 'userSurvey' }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    const whereCondition = { "types": "userSurvey", function: 'filter', filter: props.filterArray };

    getUserSurveyAutomationList(whereCondition, 50, props.pageNo);
    getAutomationListCnt(whereCondition, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteSurvey && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData != undefined && Object.keys(props.newData).length > 0) {
    props.overlayName === 'addSurvey' && createAutomation(props.newData.name, props.newData.description, props.newData.jsonData, props.dartNo, props.tenant);

    props.overlayName === 'editSurvey' && modifyAutomation(props.newData.name, props.newData.description, props.newData.jsonData, props.dartNo, props.rowID, props.tenant);
  } else if (!(props.saveBtnClicked) && props.overlayName === 'editSurvey') {
    getUserSurveyAutomationList({ dartid: props.dartNo, id: props.rowID, types: 'userSurvey' }, null, null);
  } else if (props.exportBtnClicked) {
    getExportData({ types: 'userSurvey', function: 'export', tenant: props.tenant });
  } else {
    props.overlayName !== 'addSurvey' && getUserSurveyAutomationList({ dartid: props.dartNo, types: 'userSurvey' }, 50, props.pageNo);

    props.overlayName === '' && getAutomationListCnt({ dartid: props.dartNo, types: 'userSurvey' }, props.setTotalRecords, props.setTotalPages);
  }
}

export { surveyConfiguration }